import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { downloadBlob } from '@/shared/utils/downloadBlob'

import {
  retryAttachment,
  sendAttachment,
  type SendingItem,
  type SendResult,
  useAttachmentUploads,
} from './attachmentUploads'
import { uploadName } from './recordingImageApi'

export type { SendingItem } from './attachmentUploads'

// 資料を記録に送る。1 枚ごとに送信中の行 (栄養の panel はタイル) を出し、送れなかった (60 秒で返事が無い・
// 通信・サーバの失敗) 1 枚は残して送り直せる・端末に保存できる。断られた理由と、送る形にできなかった理由は reason の 1 行。
// 送信中・送れなかった 1 枚は記録ごとの置き場 (attachmentUploads) に持つので、部品が消えても残り、
// 同じ記録のタブ・節・panel のどれにも出る
// (design-book 02-components/attachments-panel.md「送信中の行」「送れなかった行」)。
export const useAttachmentSending = (yakurekiId: string) => {
  const queryClient = useQueryClient()
  const uploads = useAttachmentUploads()
  const sending = uploads.filter((i) => i.yakurekiId === yakurekiId)
  const [reason, setReason] = useState<string | null>(null)

  const settle = async (result: Promise<SendResult>) => {
    const settled = await result
    if (!settled.ok && settled.reason) setReason(settled.reason)
    return settled
  }

  const add = (blob: Blob) =>
    settle(sendAttachment(queryClient, yakurekiId, blob))

  const retry = (item: SendingItem) =>
    settle(retryAttachment(queryClient, item))

  const save = (item: SendingItem) =>
    downloadBlob(item.blob, uploadName(item.blob, '資料'))

  return {
    sending,
    add,
    retry,
    save,
    reason,
    setReason,
  }
}
